<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">收款配置</span></div>
		<div class="h-panel-body">
			<Row type="flex" :space="30">
				<Cell :width="8">
					<div class="pay-preview">
						<div class="pay-preview-title">当前收款二维码</div>
						<img v-if="config.hasQr" :src="qrImgUrl" class="pay-preview-qr" alt="收款二维码"/>
						<div v-else class="pay-preview-empty">暂未配置收款二维码</div>
						<div class="pay-preview-info">价格：<b class="red-color">¥{{config.price}}</b></div>
						<div class="pay-preview-info">标题：{{config.title}}</div>
					</div>
				</Cell>
				<Cell :width="12">
					<Form :labelWidth="100">
						<FormItem label="收款二维码:">
							<input type="file" accept="image/jpeg,image/png,image/webp" @change="onFileChange"/>
							<div class="pay-tip">支持 jpg/png/webp，大小不超过 2MB</div>
							<img v-if="previewUrl" :src="previewUrl" class="pay-preview-new" alt="新二维码预览"/>
						</FormItem>
						<FormItem label="会员价格:">
							<input type="number" v-model="form.price" placeholder="例如 498"/>
						</FormItem>
						<FormItem label="支付标题:">
							<input type="text" v-model="form.title" maxlength="64" placeholder="例如 微信扫码支付"/>
						</FormItem>
						<FormItem>
							<Button color="primary" :loading="saving" @click="save">保存</Button>
						</FormItem>
					</Form>
				</Cell>
			</Row>
			</div>
			<div class="h-panel-bar"><span class="h-panel-title">支付订单</span></div>
			<div class="margin-top margin-left margin-right">
				<div style="display: flex;">
					<select v-model="orderStatus" style="width: 140px; margin-right: 10px;" @change="doOrderSearch">
						<option value="">全部状态</option>
						<option value="0">待支付</option>
						<option value="1">已支付</option>
						<option value="2">已关闭</option>
					</select>
					<input type="text" v-model="orderNo" placeholder="输入订单号搜索" style="width: 220px;"
						   @keyup.enter="doOrderSearch"/>
					<Button color="primary" :loading="orderLoading" @click="doOrderSearch">搜索</Button>
				</div>
			</div>
			<div class="h-panel-body">
				<Table :datas="orderList" :loading="orderLoading">
					<TableItem prop="orderNo" title="订单号" :width="180"/>
					<TableItem prop="userMobile" title="用户账号" :width="130"/>
					<TableItem prop="userName" title="用户姓名"/>
					<TableItem title="金额" :width="100" align="center">
						<template slot-scope="{data}"><b class="red-color">¥{{ data.amount }}</b></template>
					</TableItem>
					<TableItem title="状态" :width="90" align="center">
						<template slot-scope="{data}">
							<span :class="data.status === 1 ? 'green-color' : (data.status === 2 ? 'gray-color' : 'orange-color')">
								{{ data.status === 1 ? '已支付' : (data.status === 2 ? '已关闭' : '待支付') }}
							</span>
						</template>
					</TableItem>
					<TableItem prop="payChannel" title="支付渠道" :width="110"/>
					<TableItem title="创建时间" :width="150">
						<template slot-scope="{data}">{{ datetimeFormat(data.createDate) }}</template>
					</TableItem>
					<TableItem title="支付时间" :width="150">
						<template slot-scope="{data}">{{ datetimeFormat(data.payTime) }}</template>
					</TableItem>
					<TableItem title="操作" :width="150" align="center">
						<div class="actions" slot-scope="{data}" v-if="data.status === 0">
							<span @click="confirmOrder(data)">确认收款</span>
							<span @click="closeOrder(data)">关闭</span>
						</div>
					</TableItem>
				</Table>
				<Pagination style="margin-top: 10px;" v-model="orderPagination" layout="total,sizes,pager,jumper"
							@change="loadOrders" small align="right"/>
			</div>
		</app-content>
	</template>

<script>
	import Ajax from '../../js/common/ajax';
	import moment from 'moment';

	export default {
		name: "AdminPayment",
		data() {
			return {
				saving: false,
				config: {title: '微信扫码支付', price: 498, qrUrl: '', hasQr: false},
				form: {price: '', title: ''},
				file: null,
				previewUrl: '',
				//支付订单
				orderLoading: false,
				orderStatus: '',
				orderNo: '',
				orderList: [],
				orderPagination: {page: 1, size: 20, total: 0}
			}
		},
		computed: {
			qrImgUrl() {
				return this.config.qrUrl ? Ajax.PREFIX + this.config.qrUrl : '';
			}
		},
		methods: {
			loadConfig() {
				this.$api.payment.config().then(({data}) => {
					this.config = data || {title: '微信扫码支付', price: 498, qrUrl: '', hasQr: false};
					this.form.price = this.config.price;
					this.form.title = this.config.title;
				});
			},
			onFileChange(e) {
				let file = e.target.files && e.target.files[0];
				if (!file) {
					this.file = null;
					this.previewUrl = '';
					return;
				}
				if (file.size > 2 * 1024 * 1024) {
					this.$Message.error('二维码图片不能超过 2MB');
					e.target.value = '';
					return;
				}
				this.file = file;
				this.previewUrl = URL.createObjectURL(file);
			},
			save() {
				let formData = new FormData();
				if (this.file) {
					formData.append('file', this.file);
				}
				if (this.form.price !== '' && this.form.price !== null) {
					formData.append('price', this.form.price);
				}
				if (this.form.title) {
					formData.append('title', this.form.title);
				}
				this.saving = true;
				this.$api.payment.saveConfig(formData).then(({msg}) => {
					this.$Message.success(msg || '保存成功');
					this.file = null;
					this.previewUrl = '';
					this.loadConfig();
				}).finally(() => this.saving = false);
			},
			loadOrders() {
				this.orderLoading = true;
				this.$api.admin.paymentOrders({
					page: this.orderPagination.page,
					size: this.orderPagination.size,
					status: this.orderStatus === '' ? undefined : this.orderStatus,
					orderNo: this.orderNo || undefined
				}).then(({data}) => {
					this.orderList = data.records || [];
					this.orderPagination.total = Number(data.total || 0);
				}).finally(() => this.orderLoading = false);
			},
			doOrderSearch() {
				this.orderPagination.page = 1;
				this.loadOrders();
			},
			confirmOrder(data) {
				this.$Confirm(`确认已收到订单【${data.orderNo}】的 ¥${data.amount} 款项？确认后将为该用户开通超级会员。`).then(() => {
					this.$api.admin.confirmPaymentOrder({id: data.id}).then(({msg}) => {
						this.$Message.success(msg || '已确认收款');
						this.loadOrders();
					});
				});
			},
			closeOrder(data) {
				this.$Confirm(`确认关闭订单【${data.orderNo}】？关闭后用户将无法继续支付该订单。`).then(() => {
					this.$api.admin.closePaymentOrder({id: data.id}).then(({msg}) => {
						this.$Message.success(msg || '订单已关闭');
						this.loadOrders();
					});
				});
			},
			datetimeFormat(date) {
				return date ? moment(date).format('YYYY-MM-DD HH:mm') : '';
			}
		},
		mounted() {
			this.loadConfig();
			this.loadOrders();
		}
	}
</script>

<style scoped>
	.actions span {
		color: #1890ff;
		cursor: pointer;
		margin: 0 6px;
	}

	.actions span:hover {
		text-decoration: underline;
	}

	.pay-preview-title {
		font-weight: bold;
		margin-bottom: 10px;
	}

	.pay-preview-qr {
		width: 200px;
		height: 200px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
	}

	.pay-preview-empty {
		width: 200px;
		height: 200px;
		line-height: 200px;
		text-align: center;
		color: #999;
		border: 1px dashed #e8e8e8;
		border-radius: 4px;
	}

	.pay-preview-info {
		margin-top: 10px;
	}

	.pay-preview-new {
		width: 120px;
		height: 120px;
		margin-top: 10px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
	}

	.pay-tip {
		color: #999;
		font-size: 12px;
		margin-top: 5px;
	}
</style>
